/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageBannerCarousel_messages = ReadonlyArray<{
    readonly userType: string | null;
    readonly items: ReadonlyArray<{
        readonly impressionCap: number | null;
        readonly note: {
            readonly serviceId: string | null;
            readonly content: {
                readonly title: string | null;
                readonly message: string | null;
                readonly cta: {
                    readonly text: string | null;
                    readonly url: string | null;
                } | null;
            } | null;
            readonly anchors: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly content: {
                    readonly title: string | null;
                    readonly message: string | null;
                    readonly cta: {
                        readonly text: string | null;
                        readonly url: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "MessageBannerCarousel_messages";
}>;
export type MessageBannerCarousel_messages$data = MessageBannerCarousel_messages;
export type MessageBannerCarousel_messages$key = ReadonlyArray<{
    readonly " $data"?: MessageBannerCarousel_messages$data;
    readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_messages">;
}>;



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "content",
  "storageKey": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cta",
      "storageKey": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "url",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "MessageBannerCarousel_messages",
  "type": "MessageSetModule",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "userType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "MessageSetItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "impressionCap",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "note",
          "storageKey": null,
          "args": null,
          "concreteType": "MarketingMessage",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "anchors",
              "storageKey": null,
              "args": null,
              "concreteType": "MarketingMessage",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'b8c69c904b4731a6a36180b937dc15b0';
export default node;
